import { RouteType } from "types/RouteType";
import {
  IntraSyncDesignerRoute,
  IntraSyncDesignerPreviewRoute,
} from "@intrasync/designer";

const estimatingRoutesList: RouteType[] = [
  IntraSyncDesignerRoute as unknown as RouteType,
  IntraSyncDesignerPreviewRoute as unknown as RouteType,
];

export default estimatingRoutesList;
